import React from 'react';
import styled from 'styled-components';
import { breakPoint, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    background-color: ${COLORS.white};
    border: 1px solid ${COLORS.outlineGrey};
    border-radius: 8px;
    padding: 38px 40px;

    @media(${breakPoint(1366)}) {
        padding: 38px 20px;
    }

    @media(${breakPoint(1024)}) {
        padding: 27px 20px;
    }

    @media(${breakPoint(320)}) {
        display: block;
        padding: 25px 20px;
    }
`;

const Text = styled.div`
    font: 300 32px/40px "Roboto", sans-serif;
    color: ${COLORS.black};
    display: block;
    padding-right: 20px;

    @media(${breakPoint(1024)}) {
        font-size: 24px;
        line-height: 32px;
    }

    @media(${breakPoint(320)}) {
        font-size: 20px;
        line-height: 28px;
    }
`;

const Button = styled(StyledButton)`
    margin-left: auto;
    width: auto;
    min-width: 212px;
    flex-shrink: 0;

    @media(${breakPoint(320)}) {
        width: 100%;
        margin-top: 25px;
    }
`;

const TarifChannels = ({ text, onButtonClick }) => {
    return (
        <Wrapper>
            <Text>{text}</Text>
            <Button text='Посмотреть каналы' onClick={onButtonClick}/>
        </Wrapper>
    );
};

export default TarifChannels;
